<script lang="ts" module>
  /**
   * Icon set (Sprint 2, D3): 24 px grid, 2 px strokes with square caps and mitred joins (style B). Shapes that read
   * better solid (play, pause, diamond) are filled. Always decorative: the control around an icon carries the name.
   */
  export const ICONS = {
    play: { fill: 'M7 4.5v15l12-7.5z' },
    pause: { fill: 'M6 5h4v14H6zM14 5h4v14h-4z' },
    close: { stroke: 'M6 6l12 12M18 6L6 18' },
    target: { stroke: 'M12 2v5M12 17v5M2 12h5M17 12h5M12 7a5 5 0 1 0 0 10a5 5 0 1 0 0-10' },
    follow: { stroke: 'M3 12h4M17 12h4M12 3v4M12 17v4M8 8h8v8H8z' },
    sun: {
      stroke:
        'M12 8a4 4 0 1 0 0 8a4 4 0 1 0 0-8M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
    },
    sound: { stroke: 'M4 10v4h4l5 4V6l-5 4zM16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12' },
    mute: { stroke: 'M4 10v4h4l5 4V6l-5 4zM16 9l6 6M22 9l-6 6' },
    settings: { stroke: 'M4 7h9M19 7h1M4 17h3M13 17h7M13 5h6v4h-6zM7 15h6v4H7z' },
    language: { stroke: 'M3 5h10M8 3v2M11 5c-1 4-4 7-7 9M6 9c1 2 3 4 6 5M13 21l4-10l4 10M14.5 17.5h5' },
    diamond: { fill: 'M12 3l9 9l-9 9l-9-9z' },
    chevron: { stroke: 'M9 5l7 7l-7 7' },
    list: { stroke: 'M9 6h11M9 12h11M9 18h11M4 6h2M4 12h2M4 18h2' },
    legend: { stroke: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18M12 11v6M12 7v1' },
  } as const;

  export type IconName = keyof typeof ICONS;
</script>

<script lang="ts">
  let { name, size = 20 }: { name: IconName; size?: number } = $props();

  const icon = $derived(ICONS[name] as { fill?: string; stroke?: string });
</script>

<svg class="icon" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
  {#if icon.fill}
    <path d={icon.fill} fill="currentColor" />
  {:else}
    <path
      d={icon.stroke}
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="miter"
    />
  {/if}
</svg>

<style>
  .icon {
    display: block;
    flex: none;
  }
</style>
